// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.V_dhgZ{font-size:16px;position:absolute;top:12px;color:white}html[dir='ltr'] .V_dhgZ{right:12px}html[dir='rtl'] .V_dhgZ{left:12px}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"share": `V_dhgZ`
};
export default ___CSS_LOADER_EXPORT___;
